<template>
    <div class="row">
        <div class="col-md-6">
            <label for="vue-tree-search-input">{{ conf.labels.searchbyname }}</label>
            <input type="text" class="form-control" id="vue-tree-search-input" v-model="searchInput" @keyup.enter="keyboardSearch" />
        </div>
    </div>

    <SupervisedEntitiesGroupTree />
    <button id="vue-tree-search-button" class="btn btn-rectangle" @click="SearchItems">
        {{ conf.labels.search }}
    </button>
    <button id="vue-tree-export-button" class="btn btn-rectangle" v-if="supervisedEntitiesData && supervisedEntitiesData.length" @click="exportData">
        {{ conf.labels.export }}
    </button>
    <h3 v-if="supervisedEntitiesData.length || noResults" class="supervised-results" id="vue-supervised-results" tabindex="-1" ref="seEntities">
        {{ conf.labels.searchresults }} ({{ supervisedEntitiesData.length }} {{ conf.labels.pieces }})
    </h3>
    <SupervisedEntitiesList ref="results" />

    <div v-show="searching" class="supervised-spinner" role="alert" aria-label="Haetaan"></div>
</template>

<script>
    import SupervisedEntitiesGroupTree from './SupervisedEntitiesGroupTree.vue';
    import SupervisedEntitiesList from './SupervisedEntitiesList.vue';

    import axios from 'axios';
    import 'element-plus/dist/index.css';
    import { ref, onMounted, watch } from 'vue';
    import { nextTick } from 'vue';
    import { mapActions, mapState, mapMutations } from 'vuex';
    

    export default {
        components: {
            SupervisedEntitiesGroupTree,
            SupervisedEntitiesList
        },
        computed: {
            ...mapState([
                'conf',
                'groupTree',
                'noResults',
                'errorMessage',
                'searching',
                'searchTerm',
                'supervisedEntitiesData',
                'ids',
                'isSupervisedPage',
                'focusValue'
            ]),
            searchInput: {
                get() {
                    return this.searchTerm;
                },
                set(value) {
                    this.setSearchTerm(value);
                }
            },
        },
        data: () => ({
            defaultTreeProps: {
                children: 'children',
                label: 'groupName',
                id: 'groupNumber'
            },
            
        }),
        props: {
            config: Object,
        },
        methods: {
            ...mapActions([
                'Init',
                'Search',
                'SearchItems'
            ]),
            ...mapMutations([
                'setIds',
                'setSearchParams',
                'setSearchTerm',
                'setFocusValue'
            ]),
            exportData() {
                if (this.supervisedEntitiesData === null || this.supervisedEntitiesData.length == 0)
                    return;

                var BOM = "\uFEFF";
                let csv = BOM + this.createCsv(this.supervisedEntitiesData);

                let blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                csv = "data:text/csv;charset=utf-8," + csv;

                let hash = hashCode(csv);
                let fileName = `${exportFileName}_${hash}.csv`;

                let encodedUri = encodeURI(csv);

                // hashtags must be encoded, else the links href breaks there
                // encodeURIComponent() would be an easy solution, but it encodes too much and the links don't work anymore
                encodedUri = encodedUri.replace(/#/g, '%23');
                const link = document.createElement('a');
                link.href = encodedUri;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
            },
            createCsv(items) {
                let rows = [];

                let headerRow = [
                    this.conf.labels.companyname,
                    this.conf.labels.businessidentitycode,
                    this.conf.labels.contactinformation,
                    this.conf.labels.wwwaddress,
                    this.conf.labels.supervisorsinfsa,
                    this.conf.labels.authorisationsandotheroperationgrounds,
                ];

                if (this.isSupervisedPage) {
                    headerRow.push(
                        this.conf.labels.providedservices

                    )
                }
                rows.push(headerRow);

                items.forEach(item => {
                    //let row = [];
                    let repeatablePart = [];

                    repeatablePart.push(item['companyname']);
                    repeatablePart.push(item['businessidentitycode']);

                    let contactInformation = [];
                    if (propExists(item, 'telephone'))
                        contactInformation.push(this.conf.labels.telephone + ": " + item['telephone']);
                    if (propExists(item, 'telefax'))
                        contactInformation.push(this.conf.labels.telefax + ": " + item['telefax']);
                    if (propExists(item, 'address'))
                        contactInformation.push(item['address']);
                    if (propExists(item, 'address2'))
                        contactInformation.push(item['address2']);
                    if (propExists(item, 'zipcode'))
                        contactInformation.push(item['zipcode']);
                    if (propExists(item, 'city'))
                        contactInformation.push(item['city']);
                    if (propExists(item, 'homestate'))
                        contactInformation.push(item['homestate']);

                    repeatablePart.push(contactInformation.join(', '));
                    repeatablePart.push(item['wwwaddress']);
                    repeatablePart.push(item['supervisorsinfsa'].map(s => `${s.name}${s.role}, ${this.conf.labels.telephone}: ${s.telephonenumber}`).join(', '));
                    repeatablePart.push(item['authorisationsandotheroperationgrounds'].map(x => x.authorisationname).join(', '));

                    if (this.isSupervisedPage) {
                        repeatablePart.push(item['providedservices'].map(x => x.servicename).join(', '));
                    }
                    rows.push(repeatablePart);
                })

                return rows.map(row => {
                    return row.map(x => x ? x.toString().replace(/(\r\n|\n|\r)/gm, '') : '').join(';');
                }).join('\r\n');
            },
            async keyboardSearch() {
                this.SearchItems().then(() => {
                    //this.$refs.seEntities.focus();
                });
            },
            recordFocus(e) {
                //console.log(e.target);
                this.setFocusValue(e.target);
            }
        },
        created() {
            this.Init(this.config);

            document.addEventListener('focusin', this.recordFocus);
        },
        mounted() {
            
        },
        onMounted() {
            
        },
        watch: {
            
        }
    }


    const hashCode = function (s) {
        var h = 0, l = s.length, i = 0;
        if (l > 0)
            while (i < l)
                h = (h << 5) - h + s.charCodeAt(i++) | 0;
        return h;
    };

    const propExists = (item, prop) => {
        return item[prop] && item[prop] !== "";
    };

    const exportFileName = window.conf.exportFileName ? window.conf.exportFileName : "export";
</script>

<style lang="scss">
    
</style>